// extracted by mini-css-extract-plugin
export default {"container":"shell__container--b4DOD","main-content":"shell__main-content--VbSsO","footer":"shell__footer--vFtt3"};